import { Button, Flex, Text } from '@chakra-ui/react';
import React, { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';
import { Icon, PermissionButton } from '@lon/shared/components';
import { routes } from '@lon/shared/configs';
import { DistrictPermission } from '@lon/shared/enums';
import { useQueryParams } from '@lon/shared/hooks';
import { ModuleEnum, OperationEnum } from '@lon/shared/types';

const NoClassesByFilter: FC = () => {
  const { t } = useTranslation();
  const [params, setParams] = useQueryParams();
  const isArchived = params.isArchived === 'true';

  return (
    <Flex
      flexGrow="1"
      direction="column"
      align="center"
      justify="center"
      gap="6"
      color="primary.800"
      bgColor="white"
      borderRadius="6px"
      px="8"
    >
      <Flex
        direction="column"
        align="center"
        gap="4"
        textAlign="center"
        maxW="450px"
      >
        <Text variant="h5" className="tr-skip">
          {t(
            isArchived
              ? 'classes.noArchivedClassesTitle'
              : 'classes.noActiveClassesTitle'
          )}
        </Text>
        <Text variant="n3" className="tr-skip" maxW="330px">
          {t(
            isArchived
              ? 'classes.noArchivedClassesDesc'
              : 'classes.noActiveClassesDesc1'
          )}
        </Text>

        {!isArchived && (
          <Text variant="n3" className="tr-skip" maxW="360px">
            {t('classes.noActiveClassesDesc2')}
          </Text>
        )}
      </Flex>
      <Icon name="rocket-no-data" />
      {isArchived ? (
        <Button
          variant="outline"
          onClick={() => {
            setParams(
              {
                isArchived: undefined,
                grade: undefined,
              },
              { replace: true }
            );
          }}
          className="tr-skip"
          rightIcon={<Icon name="arrow-right-outlined" size="lg" />}
        >
          <Text as="span" isTruncated className="tr-skip">
            {t('classes.showMeActiveClasses')}
          </Text>
        </Button>
      ) : (
        <Flex gap={4}>
          <Button
            variant="outline"
            onClick={() => {
              setParams(
                {
                  isArchived: 'true',
                  grade: undefined,
                },
                { replace: true }
              );
            }}
            className="tr-skip"
            rightIcon={<Icon name="arrow-right-outlined" size="lg" />}
          >
            <Text as="span" isTruncated className="tr-skip">
              {t('classes.showMeArchivedClasses')}
            </Text>
          </Button>

          <PermissionButton
            module={ModuleEnum.classes}
            operation={OperationEnum.create}
            tooltip={t('classes.createClassBtn')}
            feature="Create Class"
            districtPermission={DistrictPermission.TEACHER_SUIT}
          >
            <Button
              as={Link}
              to={routes.classes.create}
              variant="solid"
              leftIcon={<Icon name="plus" />}
            >
              <Text as="span" isTruncated className="tr-skip">
                {t('classes.createClassBtn')}
              </Text>
            </Button>
          </PermissionButton>
        </Flex>
      )}
    </Flex>
  );
};

export default NoClassesByFilter;
